import { EditableDropdown } from '../EditableDropdown';
import { MenuItem } from '../../types/commonTypes';
import { ReactNode } from 'react';
import { Label } from '../Label';

export const EditableDetails = ({
  editing,
  loading,
  options,
}: EditableDetailsProps) => {
  function sortMenuItems(a: MenuItem, b: MenuItem) {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  }

  const getDetailField = (option: DetailOption) => {
    if (option.type === 'select' && editing) return renderSelect(option);
    else if (option.type === 'button' && option.button !== undefined)
      return renderCustomComponent(option.label, option.button);
    else if (option.type === 'input' && option.input !== undefined && editing)
      return renderCustomComponent(option.label, option.input, option.required);
    else return renderText(option, option.type === 'select');
  };

  const renderSelect = (option: DetailOption) => (
    <EditableDropdown
      disabled={loading}
      editing={editing}
      handleChange={
        option.name !== undefined
          ? option.onChange
          : (value) =>
              option.onChange !== undefined ? option.onChange(value) : undefined
      }
      label={option.label}
      name={option.name}
      menuItems={option.menuItems?.sort(sortMenuItems).slice() || []}
      permission={option.permission ?? true}
      required={option.required}
      value={option.value}
    />
  );

  const renderText = (option: DetailOption, fromSelect: boolean) => {
    return (
      <Label text={option.label}>
        {fromSelect && option.menuItems
          ? option.menuItems.find((i) => i.id === option.value)?.name || 'N/A'
          : option.value.toString()}
      </Label>
    );
  };

  const renderCustomComponent = (
    label: string,
    component: ReactNode,
    required?: boolean
  ) => (
    <Label required={required} text={label}>
      {component}
    </Label>
  );

  return (
    <div className="flex flex-row flex-wrap text-left gap-8">
      {options
        .sort((a, b) => (a.order < b.order ? -1 : 1))
        .map((option, index) =>
          option.display ? (
            <div
              key={`account-detail-${index}`}
              className="whitespace-nowrap min-w-[60px]"
            >
              {getDetailField(option)}
            </div>
          ) : null
        )}
    </div>
  );
};
